import React from "react";
import clsx from "clsx";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import styles from "./index.module.css";
import { formatDateTime } from "../../utils/dateUtils";

const Timeline = ({ timelineData, progressWidth }) => {
    const getStatusColor = (status) => {
      switch (status) {
        case "Success":
          return "#00A300";
        case "Rejected":
        case "Cancelled":
        case "Failed":
        case "Zoho Failed":
          return "#FF0000";
        default:
          return "#28a745";
      }
    };

  return (
    <div
      className={styles.timeline}
      style={{ "--progress-width": `${progressWidth}%` }}
    >
      {timelineData.map((stepData) => {
        const { label, isCompleted, isActive, log } = stepData;
        const isNegativeStatus =
          log?.status === "Failed" ||
          log?.status === "Rejected" ||
          log?.status === "Cancelled" ||
          log?.status === "Zoho Failed";

        const dotStyle = {};
        if (isActive && log) {
          dotStyle.borderColor = getStatusColor(log.status);
          dotStyle.backgroundColor = "#fff";
        } else if (isCompleted) {
          dotStyle.borderColor = getStatusColor(log?.status);
          dotStyle.backgroundColor = getStatusColor(log?.status);
        }

        return (
          <div
            key={label}
            className={clsx(styles.timelineStep, {
              [styles.active]: isActive,
              [styles.completed]: isCompleted,
            })}
          >
            <div className={styles.timelineDot} style={dotStyle}>
              {((isCompleted && !isActive) || log?.status === "Success") && (
                <IoMdCheckmarkCircleOutline
                  className={clsx({
                    [styles.successIcon]: log?.status === "Success",
                    [styles.checkmarkIcon]: log?.status !== "Success",
                  })}
                />
              )}

              {isCompleted &&
                !isActive &&
                isNegativeStatus &&
                log?.status !== "Success" && (
                  <RxCross2 className={styles.crossIcon} />
                )}

              {isActive && isNegativeStatus && (
                <RxCross2 className={styles.crossIcon} />
              )}
            </div>

            <span style={{ color: log ? getStatusColor(log.status) : "" }}>
              {log ? log.status : label}
            </span>

            {log && (
              <div className={styles.stepDetails}>
                <span className={styles.stepTimestamp}>
                  {formatDateTime(log.timestamp)}
                </span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
